<template>
  <div class="bg-brand-grey-light/60 hidden h-8 w-px lg:block"></div>
</template>
